export const shouldNoIndex = (path: string) =>
  (path?.includes("?") && !path?.includes("page=")) || path?.includes("&");
